import { render, staticRenderFns } from "./MobileBackButton.vue?vue&type=template&id=ae955fea&scoped=true&"
import script from "./MobileBackButton.vue?vue&type=script&lang=js&"
export * from "./MobileBackButton.vue?vue&type=script&lang=js&"
import style0 from "./MobileBackButton.vue?vue&type=style&index=0&id=ae955fea&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae955fea",
  null
  
)

export default component.exports